import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useAppSelector } from '@/hooks';
import { useParams } from 'react-router-dom';
import { Box, Stack, Typography, IconButton, Paper } from '@mui/material';
import img from '@/assets/images/delivery.png';
import { X } from 'lucide-react';

const DeliveryOffDialog = () => {
  const [open, setOpen] = useState(false);
  const { organizationId } = useParams<{ organizationId: string }>();
  const organization = useAppSelector(
    (state) => state.organizations[organizationId]
  );

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const isDeliveryEnabled =
      organization?.settings?.services?.delivery?.isEnabled;

    const flow = new URLSearchParams(window.location.search).get('flow') ?? '';

    if (organization?.id && !isDeliveryEnabled && flow.includes('delivery')) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    organization?.id,
    organization?.settings?.services?.delivery?.isEnabled,
    window.location.search,
  ]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs">
      <Box
        sx={{
          height: 400,
          backgroundImage: `url(${img})`,
          backgroundPosition: 'center',
          backgroundSize: 400,
          marginBottom: '-32px',
          position: 'relative',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#d4ebf1',
        }}
      >
        <Paper
          sx={{
            borderRadius: '50%',
            position: 'absolute',
            right: 16,
            top: 16,
          }}
        >
          <IconButton onClick={handleClose} color="primary">
            <X />
          </IconButton>
        </Paper>
      </Box>
      <DialogContent>
        <Stack alignItems="center" gap={2}>
          <br />
          <Typography variant="body1" textAlign="center">
            El servicio de
          </Typography>
          <Typography variant="h2" textAlign="center" color="primary">
            Delivery
          </Typography>
          <Typography variant="body1" textAlign="center">
            no está disponible ahora mismo.
          </Typography>
          <Typography variant="body1" textAlign="center">
            Pero puedes ordenar y recoger tu pedido en nuestro restaurante.
          </Typography>
          <Button size="large" onClick={handleClose}>
            Continuar
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeliveryOffDialog;
